import angular from 'angular';
import constants from 'app/constants';
import {
  oversightDataService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
// import editAuditDialog from '../../dialog.editAuditDialog';
import controller from './mark-agendaItem-complete-confirm-dialog.controller';
import template from './mark-agendaItem-complete-confirm-dialog.html';
import agendaItemCompleteDateMessagesTpl from '../../../messages/agenda-item-complete-date.messages.html';

class dialogService {
  getOptions($event, {
    item, refreshAgendaItem, canSave, users
  }) {
    return {
      controller,
      controllerAs: 'markAgendaItemCompleteConfirmDialogVM',
      locals: {
        item,
        refreshAgendaItem,
        canSave,
        users,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.oversight.markAgendaItemCompleteConfirmDialog', [
  alerts,
  oversightDataService,
  constants,
  // editAuditDialog,
  loaderService,
  ssDialogService,
])
  .service('markAgendaItemCompleteConfirmDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('agenda-item-complete-date.messages.html', agendaItemCompleteDateMessagesTpl);
  })
  .name;
